import {IEmailSettingsFormState} from '../models';
import {IEmailSettings} from '../../../../settings-new/models';

export const initialState: IEmailSettingsFormState = {
  colleagues: [],
  canManageColleagueEmails: false,
  colleaguesEmailSettings: {},
  selectedColleague: null,
  selectedColleagueEmailSettings: null,
  selectedStore: null,
  filteredColleagues: [],
  userQuery: '',
  formErrors: {
    email: '',
    user: '',
    pwd: '',
    smtp: {
      server: '',
      port: '',
    },
    imap: {
      server: '',
      port: '',
    },
  },
  isLoadingSettings: false,
  isSubmitting: false,
};

export const defaultEmailSettings: IEmailSettings = {
  email: '',
  user: '',
  pwd: '',
  smtp: {
    server: '',
    port: 0,
    sslOnly: false,
  },
  imap: {
    server: '',
    port: 0,
    sslOnly: false,
    sentBox: '',
  },
  enableImap: false,
} as const;
